
export default "/assets/buysellads.0f9ca488.svg"